module.exports = __webpack_public_path__ + "img/category-casino-hover.ae63024f.png";